import {
  BooleanCons,
  StringConst,
  TypeCatalogs,
} from 'src/app/constants/const';
import { ISelectCatalogs, ParamsSearch, SelectedItemsClassification } from '../http/catalogs';

export interface CatalogFilter {
  filter(data: CatalogFilterDefinition): CatalogFilterDefinition;
}

export class CatalogFilterDefinition {
  typeCatalog: TypeCatalogs;
  activeFilters: ParamsSearch;
  toppings: ISelectCatalogs;
  selectedItems: SelectedItemsClassification;
  availableItems: SelectedItemsClassification;
  needReloadFilters: boolean;
  searchItemCodeExact: boolean;
  constructor() {
    this.typeCatalog = TypeCatalogs.default;
    this.activeFilters = new ParamsSearch();
    this.toppings = {
      ailments: [],
      specialities: [],
      actives: [],
      presentation: [],
      sublines: [],
      indication: [],
    };
    this.selectedItems = new SelectedItemsClassification();
    this.availableItems = new SelectedItemsClassification();
    this.needReloadFilters = BooleanCons.true;
    this.searchItemCodeExact = BooleanCons.false;
  }
}
export class CatalogFiltersShow {
  sublineConfig: boolean;
  ailmentConfig: boolean;
  activePrincipleConfig: boolean;
  presentationConfig: boolean;
  medicalIndicationConfig: boolean;
  codeConfig: boolean;
  generalSearchConfig: boolean;
  specialtyConfig: boolean;
  indicationConfig: boolean;
  constructor() {
    this.sublineConfig = BooleanCons.false;
    this.ailmentConfig = BooleanCons.false;
    this.activePrincipleConfig = BooleanCons.false;
    this.presentationConfig = BooleanCons.false;
    this.medicalIndicationConfig = BooleanCons.false;
    this.codeConfig = BooleanCons.false;
    this.generalSearchConfig = BooleanCons.false;
    this.specialtyConfig = BooleanCons.false;
    this.indicationConfig = BooleanCons.false;
  }
}

export class ConfigInputStyleCatalog {
  ailment: string;
  speciality: string;
  active: string;
  presentation: string;
  generalSearch: string;
  code: string;
  subLines: string;
  erase: string;
  medicalIndication: string;
  indication: string;
  constructor() {
    this.ailment = StringConst.empty;
    this.speciality = StringConst.empty;
    this.active = StringConst.empty;
    this.presentation = StringConst.empty;
    this.generalSearch = StringConst.empty;
    this.code = StringConst.empty;
    this.subLines = StringConst.empty;
    this.erase = StringConst.empty;
    this.medicalIndication = StringConst.empty;
    this.indication = StringConst.empty;
  }
}

